import classNames from "classnames";
import React from "react";

export default function ({
  className,
  name,
  placeholder,
  value,
  onChange,
  onSubmit,
  hideIcon,
}) {
  const submitHandler = (e) => {
    e.preventDefault();

    if (typeof onSubmit === "function") {
      onSubmit(e);
    }
  };

  return (
    <form
      className={classNames("search", { [className]: !!className })}
      onSubmit={submitHandler}
    >
      <div className="search__field">
        {hideIcon !== false && (
          <img
            src="/assets/images/page-icons/magnifier.svg"
            alt="search"
            className="search__magnifier"
          />
        )}
        <input
          type="text"
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="search__input"
        />
      </div>
    </form>
  );
}
